export function Field({ label, errorMessage, helperText, htmlFor, children }) {
  return (
    <div className="flex gap-2 flex-col">
      <label htmlFor={htmlFor} className={`text-[#333333] text-sm ${htmlFor ? "cursor-pointer" : ""}`}>
        {label}
      </label>
      {children}
      {errorMessage && (
        <div className="text-red-700 text-sm">{errorMessage}</div>
      )}
      {helperText && (
        <p className="text-sm text-light text-muted-foreground italic">{helperText}</p>
      )}
    </div>
  );
}
